"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var Component = /** @class */ (function (_super) {
    tslib_1.__extends(Component, _super);
    function Component() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        return _this;
    }
    Component.prototype.getMap = function () {
        // @ts-ignore
        return this.props.map || this.context.map;
    };
    Component.prototype.getInstance = function (component) {
        return component.instance;
    };
    Component.prototype.getOptions = function (props) {
        if (props === void 0) { props = this.props; }
        var options = {};
        this.options.map(function (key) {
            if (props[key] !== undefined) {
                options[key] = props[key];
            }
        });
        return options;
    };
    return Component;
}(react_1.PureComponent));
exports.default = Component;
